import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Award, Flag, MapPin } from "lucide-react";
import Header from "../components/Header";
import ClientGrid from "../components/ClientGrid";
import Footer from "../components/Footer";
import { PAGE_CONTENT_CLASS } from "../data/products";
import { AnimatedCountUp } from "../components/AnimatedNumber";

const ClientsPage = () => {
  return (
    <div className="min-h-screen bg-[#1a0f08]">
      <Header />
      <main id="main-content" className="pt-24 pb-16 bg-[#0D0D0D] min-h-screen">
        <div className={PAGE_CONTENT_CLASS}>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[#d4a574] hover:text-[#c9923f] transition-colors mb-8 text-sm uppercase tracking-wider"
          >
            <ArrowLeft size={18} />
            Back to Home
          </Link>

          <h1 className="text-4xl lg:text-5xl font-bold text-white mb-8">
            Our Clients Across India
          </h1>

          <div className="flex flex-wrap gap-4 mb-12">
            <div className="flex items-center gap-2 bg-[#2a1810] px-4 py-2 rounded border border-[#c9923f]/20">
              <Flag className="text-[#d4a574]" size={18} />
              <span className="text-white/90 text-sm">Made in India</span>
            </div>
            <div className="flex items-center gap-2 bg-[#2a1810] px-4 py-2 rounded border border-[#c9923f]/20">
              <Award className="text-[#d4a574]" size={18} />
              <span className="text-white/90 text-sm">
                <AnimatedCountUp value={1000} suffix="+" /> Installations
              </span>
            </div>
            <div className="flex items-center gap-2 bg-[#2a1810] px-4 py-2 rounded border border-[#c9923f]/20">
              <Award className="text-[#d4a574]" size={18} />
              <span className="text-white/90 text-sm">
                <AnimatedCountUp value={750} suffix="+" /> Clients
              </span>
            </div>
            <div className="flex items-center gap-2 bg-[#2a1810] px-4 py-2 rounded border border-[#c9923f]/20">
              <MapPin className="text-[#d4a574]" size={18} />
              <span className="text-white/90 text-sm">Pan India</span>
            </div>
          </div>

          <ClientGrid />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ClientsPage;
